import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { WorkExperience } from '../../../class/work-experience';
import { WorkExperienceService } from '../../../service/work-experience/work-experience.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { formatDateWithouthHourConditional } from '../../../../../theme/functions/formatDateWithouthHourConditional.function';
import { calendarES } from '../../../../../theme/functions/calendarES';
import { formatDate } from '../../../../../theme/functions/formatDate.function';

@Component({
  selector: 'app-new-work-experience',
  templateUrl: './new-work-experience.component.html',
  styleUrls: ['./new-work-experience.component.scss']
})
export class NewWorkExperienceComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: WorkExperience;
    @Input() idCandidate: string;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public company: AbstractControl;
    public employee_position: AbstractControl;
    public job_functions: AbstractControl;
    public start: AbstractControl;
    public end: AbstractControl;
    public contact_name: AbstractControl;
    public contact_phone: AbstractControl;
    public present: AbstractControl;
    public activated: AbstractControl;

    public es: any;

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public workExperienceService: WorkExperienceService,
        public translate: TranslateService,
        private ngZone: NgZone,
        private notificationsService: NotificationsService,
        private mapsAPILoader: MapsAPILoader) {

        this.save_exit = false;

        this.es = calendarES();

        this.form = fb.group({
            'company': ['', Validators.compose([ Validators.required, Validators.minLength(3) ])],
            'employee_position': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
            'job_functions': ['', Validators.compose([ Validators.required, Validators.minLength(10), Validators.maxLength(1500) ]) ],
            'start': ['', Validators.compose([ Validators.required, Validators.minLength(1) ]) ],
            'end': [''],
            'contact_name': ['', Validators.compose([ Validators.minLength(3) ]) ],
            'contact_phone': ['', Validators.compose([ Validators.minLength(7), Validators.maxLength(10), Validators.pattern('^[0-9]*$') ]) ],
            'present': [''],
            'activated': [''],
        });

        this.company = this.form.controls['company'];
        this.employee_position = this.form.controls['employee_position'];
        this.job_functions = this.form.controls['job_functions'];
        this.start = this.form.controls['start'];
        this.end = this.form.controls['end'];
        this.contact_name = this.form.controls['contact_name'];
        this.contact_phone = this.form.controls['contact_phone'];
        this.present = this.form.controls['present'];
        this.activated = this.form.controls['activated'];
    }

    ngOnInit() {
        if (this.edit) {
            this.company.setValue(this.edit.company);
            this.employee_position.setValue(this.edit.employee_position);
            this.job_functions.setValue(this.edit.job_functions);
            this.start.setValue(new Date(this.edit.start));
            if(this.edit.end)
                this.end.setValue(new Date(this.edit.end));

            this.contact_name.setValue(this.edit.contact_name);
            this.contact_phone.setValue(this.edit.contact_phone);
            this.present.setValue(this.edit.present);
            this.activated.setValue(this.edit.activated);
        } else {
            this.activated.setValue(true);
        }
    }

    public cancelWorkExperience () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public saveandexit (values){
        this.save_exit = true;
        this.newWorkExperience(values);
    }

    public newWorkExperience(values: WorkExperience) {
        let param;
        if (this.idCandidate) {
            param = {
                'candidate_id': this.idCandidate,
                'company': values.company,
                'employee_position': values.employee_position,
                'job_functions': values.job_functions,
                'start': formatDate(values.start),
                'end': (values.present == false) ? formatDate(values.end) : null,
                'contact_name': values.contact_name,
                'contact_phone': values.contact_phone,
                'present': values.present,
                'activated': values.activated,
            };
        } else {
            // param = {
            //     'candidate_id': values.candidate_id,
            //     'degree': values.degree,
            //     'education_level': values.education_level,
            //     'institution': values.institution,
            //     'start': formatDateWithouthHourConditional(values.start),
            //     'end': formatDateWithouthHourConditional(values.end),
            //     'present': values.present,
            //     'activated': values.activated,
            // };
        }
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.workExperienceService.updateWorkExperience(this.edit.id, param)
                :
                this.workExperienceService.newWorkExperience(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    getRequiredDataEnd(formData) {
        if (formData == null || formData == '' || formData == undefined) {
            formData = false;
            this.form.get('present').setValue(false);
        }
    
        if(formData == false)
            this.form.get('end').setValidators([ Validators.required ]);
        else
            this.form.get('end').setValidators([ ]);
        
        this.form.get('end').updateValueAndValidity();
    
        return formData;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/work-experiences/new-work-experience/new-work-experience.component.ts